import React from "react";

export const useGetAvailableSpace = (isOpen: boolean, triggerRef: React.RefObject<HTMLElement>) => {
  const [maxHeight, setMaxHeight] = React.useState<string>("500px");

  React.useLayoutEffect(() => {
    const updateHeight = () => {
      if (!triggerRef.current) return;

      const rect = triggerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom - 115;
      const spaceAbove = rect.top - 115;

      const available = Math.max(spaceBelow, spaceAbove);
      setMaxHeight(`${Math.min(available, 500)}px`);
    };

    if (!isOpen || !triggerRef.current) {
      return () => window.removeEventListener("resize", updateHeight);
    }

    updateHeight();

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [isOpen, triggerRef]);

  return maxHeight;
};
